import { render, staticRenderFns } from "./OpenaiTemplate.vue?vue&type=template&id=41b1840e&"
import script from "./OpenaiTemplate.vue?vue&type=script&lang=js&"
export * from "./OpenaiTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports